// extracted by mini-css-extract-plugin
module.exports = {"constructorWrapper":"draggable-ingredient_constructorWrapper__32JYu"};